import { matchRoutes } from 'react-router-dom';
import { some, flatMap, get, find, findIndex, compact } from 'lodash';
import {
  MODELS,
  CONFIG,
  TRIMS,
  EXTERIOR,
  WHEELS,
  INTERIOR,
  PACKAGES,
  OPTIONS,
  SUMMARY,
  PACKAGES_AND_OPTIONS,
} from '../common/steps';

const hasSomeOptions = (groups) => some(flatMap(groups));

const isStepEnabled = (step, config) => {
  switch (step.key) {
    case MODELS:
    case CONFIG:
    case TRIMS:
    case SUMMARY:
      return true;
    case PACKAGES_AND_OPTIONS:
      return hasSomeOptions(config.packagesAndOptions);
    case EXTERIOR:
      return hasSomeOptions(config.exterior);
    case WHEELS:
      return hasSomeOptions(config.wheels);
    case INTERIOR:
      return hasSomeOptions(config.interior);
    case PACKAGES:
      return hasSomeOptions(config.packages);
    case OPTIONS:
      return hasSomeOptions(config.options);
    default:
      return false;
  }
};

const computeSteps = (
  steps,
  config,
  location,
  basename,
  hasTransactionId,
  reservation
) => {
  const configSteps = get(config, 'config.steps');
  const stepsWithOptions = configSteps.map((step) =>
    find(steps, { key: step.key })
  );

  const orderedSteps = compact([
    find(steps, { key: MODELS }),
    find(steps, { key: CONFIG }),
    find(steps, { key: TRIMS }),
    ...stepsWithOptions,
    find(steps, { key: SUMMARY }),
  ]);

  const getLabel = (step) => {
    const { key, label, tidLabel } = step;

    switch (key) {
      case TRIMS:
        return reservation?.preOrderStyleId ? tidLabel : label;
      case SUMMARY:
        return hasTransactionId ? tidLabel : label;
      default:
        return label;
    }
  };

  const items = orderedSteps
    .filter((step) => isStepEnabled(step, config))
    .map((step, index) => {
      const { key, path, matchPath } = step;

      return {
        key,
        label: getLabel(step),
        path,
        active: !!matchRoutes(
          [{ path: matchPath }],
          location.pathname,
          basename
        ),
        index: index + 1,
      };
    });

  const activeIndex = findIndex(items, 'active');
  if (activeIndex === -1) {
    return {
      items,
    };
  }

  return {
    items,
    prev: items[activeIndex - 1],
    active: items[activeIndex],
    next: items[activeIndex + 1],
  };
};

export default computeSteps;
